import {
  AnalyticsEventDataType,
  BARCODE_ACTIONS_VALUES,
  BARCODE_VALUE,
  BarcodeAnalyticsEventData,
  CATEGORY_SET_VALUE,
} from 'b2b-apps/shop/analytics/redux';
import {
  TEALIUM_INTERACTION_ID,
  TEALIUM_PROD_ACTION,
} from 'b2b-apps/shop/analytics/types/types';
import {
  preparePrice,
  prepareStock,
} from 'b2b-apps/shop/analytics/utils/analytics';


export const createBarcodeAnalyticsEventData = ({
  barcodeAction,
  barcode,
  productTile,
}: BarcodeAnalyticsEventData): AnalyticsEventDataType => {
  const addBarcode = barcode && { component_attribute4: [barcode] };
  switch (barcodeAction) {
    case (TEALIUM_PROD_ACTION.open):
    case (TEALIUM_PROD_ACTION.cameraSuccess):
    case (TEALIUM_PROD_ACTION.cameraError):
    case (TEALIUM_PROD_ACTION.productNotFound):
      return {
        interaction: TEALIUM_INTERACTION_ID.barcodeScan,
        component_category: [CATEGORY_SET_VALUE],
        component_subcategory: [BARCODE_VALUE],
        component_location: [BARCODE_VALUE],
        component_attribute3: [barcodeAction],
        ...addBarcode,
      };
    case (TEALIUM_PROD_ACTION.productFound):
    case (TEALIUM_PROD_ACTION.productListClick):
    case (TEALIUM_PROD_ACTION.addToWishlist):
    case (TEALIUM_PROD_ACTION.addToCartFromList):
      return {
        interaction: TEALIUM_INTERACTION_ID.barcodeScan,
        component_category: [''],
        component_subcategory: [''],
        component_location: [BARCODE_VALUE],
        component_attribute1: [''],
        component_attribute3: [barcodeAction],
        ...addBarcode,
        ...(productTile)
        && {
          prod: [
            {
              id: productTile.data.sku,
              price: preparePrice(productTile.data.pricing.user.price),
              ...(barcodeAction === TEALIUM_PROD_ACTION.addToCartFromList)
              && { quan: '1' },
              pos: `${1}`,
              stock: prepareStock(productTile.data.settings.quantity),
              categories: productTile.data.analytics.categories,
              action: BARCODE_ACTIONS_VALUES[barcodeAction],
              list: BARCODE_VALUE,
            },
          ],
        },
      };
    default:
      return {};
  }
};
